var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vms__ui-button vms__OpenSansRegular",class:{
    'vms__ui-button--disabled': _vm.disabled,
    'vms__ui-button--shadow': _vm.shadow,
    'vms__ui-button--link': _vm.link,
    'vms__ui-button--href': _vm.href,
    'vms__ui-button--blank': _vm.blank
  },style:(_vm.propsStyles),attrs:{"title":_vm.buttonTitle,"href":!_vm.link ? _vm.href : null},on:{"click":_vm.onClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }